import { IExecutionOptions, IQueryOptions } from '@kurtosys/types/query/index.js';
import { ITransformOptions } from '@kurtosys/types/query/transforms/ITransformOptions.js';

import { commonUtils } from '../../common/index.js';

import { BaseTransform } from './BaseTransform.js';

export class ObjectTransform extends BaseTransform {
	execute(queryResponse: any, queryOptions: IQueryOptions, executionOptions: IExecutionOptions): any {
		if (commonUtils.isArrayLike(queryResponse)) {
			queryResponse = (queryResponse as any[]).map((row): any => {
				return this.applyObjectTransforms(row, queryOptions, executionOptions);
			});
		} else if (typeof queryResponse === 'object') {
			queryResponse = this.applyObjectTransforms(queryResponse, queryOptions, executionOptions);
		}
		return queryResponse;
	}
	applyObjectTransforms = (rawObj: object, queryOptions: IQueryOptions, executionOptions: IExecutionOptions): any => {
		const { objectTransformOptions } = this.options;
		if (typeof rawObj === 'object') {
			let obj = commonUtils.deepMergeObjects({}, rawObj);
			const { transforms, fields } = objectTransformOptions;
			obj = this.applyTransforms(obj, transforms, queryOptions, executionOptions);
			if (fields && commonUtils.isArrayLike(fields)) {
				fields.forEach((field): void => {
					const { key, transforms: fieldTransforms } = field;
					if (fieldTransforms && commonUtils.isArrayLike(fieldTransforms)) {
						obj[key] = this.applyTransforms(obj[key], fieldTransforms, queryOptions, executionOptions);
					}
				});
			}
			return obj;
		}
		return rawObj;
	};
	applyTransforms = (
		value: any,
		transforms: ITransformOptions[],
		queryOptions: IQueryOptions,
		executionOptions: IExecutionOptions,
	): any => {
		if (transforms) {
			for (const transformOptions of transforms) {
				const transform = new this.dependencies.transformClass(
					this.dependencies,
					transformOptions,
					this.translationHelper,
					this.callStackLevel,
				);
				value = transform.execute(value, queryOptions, executionOptions);
			}
		}
		return value;
	};
}
